import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const ContentTransparency: React.FC<Props> = ({
  className,
  width = 80,
  height = 43,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 80 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_60810_153583)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50 27.75C50 28.1642 49.6642 28.5 49.25 28.5H18.75C18.3358 28.5 18 28.1642 18 27.75C18 27.3358 18.3358 27 18.75 27H49.25C49.6642 27 50 27.3358 50 27.75Z"
          fill="#ACBDD3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62 32.25C62 32.6642 61.6642 33 61.25 33H18.75C18.3358 33 18 32.6642 18 32.25C18 31.8358 18.3358 31.5 18.75 31.5H61.25C61.6642 31.5 62 31.8358 62 32.25Z"
          fill="#ACBDD3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38 36.75C38 37.1642 37.6642 37.5 37.25 37.5H18.75C18.3358 37.5 18 37.1642 18 36.75C18 36.3358 18.3358 36 18.75 36H37.25C37.6642 36 38 36.3358 38 36.75Z"
          fill="#ACBDD3"
        />
      </g>
      <g clipPath="url(#clip1_60810_153583)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62 14.75C62 15.1642 61.6642 15.5 61.25 15.5H18.75C18.3358 15.5 18 15.1642 18 14.75C18 14.3358 18.3358 14 18.75 14H61.25C61.6642 14 62 14.3358 62 14.75Z"
          fill="#ACBDD3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50 19.25C50 19.6642 49.6642 20 49.25 20H18.75C18.3358 20 18 19.6642 18 19.25C18 18.8358 18.3358 18.5 18.75 18.5H49.25C49.6642 18.5 50 18.8358 50 19.25Z"
          fill="#ACBDD3"
        />
      </g>
      <defs>
        <clipPath id="clip0_60810_153583">
          <rect
            width="44"
            height="10.5"
            fill="white"
            transform="translate(18 27)"
          />
        </clipPath>
        <clipPath id="clip1_60810_153583">
          <rect
            width="44"
            height="6"
            fill="white"
            transform="translate(18 14)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
